import React from "react";
import { Location } from "@navigation/Location";
import { AccommodationConfirmationViewPage } from "../AccommodationDocumentUploader/AccommodationConfirmationViewPage";

type Params = {
  bookingId: string;
  confirmationId: string;
};

export class AccommodationConfirmationViewLocation extends Location<Params> {
  render(): React.ReactElement<any> {
    return (
      <AccommodationConfirmationViewPage
        bookingId={this.params.bookingId}
        confirmationId={this.params.confirmationId}
      />
    );
  }

  toURI(): string {
    const { confirmationId, bookingId } = this.params;
    return `/bookings/${bookingId}/accommodation-confirmation/${confirmationId}`;
  }
}
